/* STOCKISTS LOCATOR — list, state chips, search, "near me" and the map.
   Ported from the concept's stockists.html, where it ran inline. The theme
   carried the data file (stockists.js) across but not this, so the page loaded
   with an empty list and a blank map.

   Load order matters and is set in sections/stockists.liquid: Leaflet, the
   cluster plugin, stockists.js (the STOCKISTS array), then this file. */
(function () {
  if (typeof STOCKISTS === 'undefined') return;

  const listEl   = document.getElementById('list');
  const dotsEl   = document.getElementById('dots');
  const labelsEl = document.getElementById('labels');
  const chipsEl  = document.getElementById('chips');
  const resEl    = document.getElementById('results');
  const qEl      = document.getElementById('q');
  if (!listEl || !chipsEl || !resEl || !qEl) return;

  /* ordered by how many stores are in each, not alphabetically — alphabetical
     would open the page on the ACT's seven */
  const STATE_ORDER = ['VIC','NSW','TAS','ACT','SA','QLD','WA','NT'];
  const STATE_FULL = {VIC:'Victoria', NSW:'New South Wales', TAS:'Tasmania', ACT:'ACT',
                      SA:'South Australia', QLD:'Queensland', WA:'Western Australia', NT:'Northern Territory'};

  STOCKISTS.sort((a,b) =>
    (STATE_ORDER.indexOf(a.s) - STATE_ORDER.indexOf(b.s)) ||
    a.c.localeCompare(b.c) || a.n.localeCompare(b.n));

  /* Round down to a clean boundary and add a plus, so signing another twenty
     shops doesn't make the page wrong. */
  const durable = n =>
    (n >= 1000 ? Math.floor(n / 100) * 100 : n >= 100 ? Math.floor(n / 50) * 50 : Math.floor(n / 10) * 10) + '+';
  const tStores = document.getElementById('tStores');
  const tSub = document.getElementById('tSub');
  if (tStores) tStores.textContent = durable(STOCKISTS.length);
  if (tSub) tSub.textContent = durable(new Set(STOCKISTS.map(s => s.c + s.s)).size);

  /* chips */
  const counts = STOCKISTS.reduce((m,s) => (m[s.s] = (m[s.s]||0)+1, m), {});
  let activeState = 'ALL';
  const mkChip = (key, label, n) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'chip';
    b.setAttribute('aria-pressed', String(key === 'ALL'));
    b.dataset.state = key;
    b.innerHTML = label + (n ? ' <small>' + n + '</small>' : '');
    b.addEventListener('click', () => {
      activeState = key;
      [...chipsEl.children].forEach(c => c.setAttribute('aria-pressed', String(c === b)));
      render();
    });
    return b;
  };
  chipsEl.appendChild(mkChip('ALL','All', STOCKISTS.length));
  STATE_ORDER.filter(s => counts[s]).forEach(s => chipsEl.appendChild(mkChip(s, s, counts[s])));

  /* SVG fallback map — plain equirectangular over the data's own bounds */
  const padX = 7, padTop = 7, padBot = 15;
  const lats = STOCKISTS.map(s => s.lat), lngs = STOCKISTS.map(s => s.lng);
  const minLat = Math.min(...lats), maxLat = Math.max(...lats);
  const minLng = Math.min(...lngs), maxLng = Math.max(...lngs);
  const px = s => padX + (s.lng - minLng) / (maxLng - minLng) * (100 - padX*2);
  const py = s => padTop + (maxLat - s.lat) / (maxLat - minLat) * (102 - padTop - padBot);

  const dotFor = new Map();
  if (dotsEl) {
    STOCKISTS.forEach(s => {
      const c = document.createElementNS('http://www.w3.org/2000/svg','circle');
      c.setAttribute('cx', px(s).toFixed(2));
      c.setAttribute('cy', py(s).toFixed(2));
      c.setAttribute('r', '0.85');
      c.setAttribute('class','dot');
      dotsEl.appendChild(c);
      dotFor.set(s, c);
    });
  }
  if (labelsEl) {
    [['Melbourne',-37.81,144.96,  0,  7.5,'middle'],
     ['Sydney',   -33.87,151.21, -4, -4.5,'end'   ],
     ['Canberra', -35.28,149.13, -4,  0.6,'end'   ],
     ['Adelaide', -34.93,138.60,  3,  1.0,'start' ],
     ['Hobart',   -42.88,147.32,  3,  0.6,'start' ]].forEach(([n,lat,lng,dx,dy,anchor]) => {
      const t = document.createElementNS('http://www.w3.org/2000/svg','text');
      t.setAttribute('x', (px({lng}) + dx).toFixed(2));
      t.setAttribute('y', (py({lat}) + dy).toFixed(2));
      t.setAttribute('text-anchor', anchor);
      t.setAttribute('class','map__lbl');
      t.textContent = n;
      labelsEl.appendChild(t);
    });
  }

  /* Interactive map: Leaflet over CARTO's dark basemap, no API key. If Leaflet
     didn't load, everything below no-ops and the SVG stays. */
  let lmap = null, cluster = null, meMarker = null, meHalo = null;
  const markerFor = new Map();
  const rowFor = new Map();

  const PIN = window.L && L.divIcon({ className:'pin', html:'<i></i>', iconSize:[12,12], iconAnchor:[6,6], popupAnchor:[0,-8] });
  const PIN_ME = window.L && L.divIcon({ className:'pin pin--me', html:'<i></i>', iconSize:[14,14], iconAnchor:[7,7] });

  /* Basemap: OpenFreeMap's dark vector style, drawn by MapLibre inside Leaflet.
     No API key, no account, no view limits, and commercial use is allowed —
     attribution is the only condition. (CARTO's "key-free" tiles now serve an
     "API key required" image with a 200 status, so they can't be detected as
     failures.) Without WebGL or MapLibre it drops to OpenStreetMap's raster
     tiles, and if those are blocked too, to the SVG. */
  const OFM_STYLE = 'https://tiles.openfreemap.org/styles/dark';
  const OFM_ATTR = '<a href="https://openfreemap.org" target="_blank" rel="noopener">OpenFreeMap</a> &copy; <a href="https://www.openmaptiles.org/" target="_blank" rel="noopener">OpenMapTiles</a> Data from <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>';
  let baseLayer = null;

  function hasWebGL(){
    try { const c = document.createElement('canvas'); return !!(c.getContext('webgl2') || c.getContext('webgl')); }
    catch (e) { return false; }
  }

  function useOsm(){
    if (baseLayer) lmap.removeLayer(baseLayer);
    let fails = 0;
    baseLayer = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom:19,
      attribution:'&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors' }).addTo(lmap);
    baseLayer.on('tileerror', () => {
      if (++fails >= 6) svgFallback('Map tiles are blocked on this network — every dot is still a real stockist');
    });
  }

  function useBasemap(){
    if (!(L.maplibreGL && window.maplibregl && hasWebGL())) return useOsm();
    baseLayer = L.maplibreGL({ style: OFM_STYLE, attribution: OFM_ATTR }).addTo(lmap);
    /* the plugin doesn't always surface its attribution option — OpenFreeMap requires it */
    if (lmap.attributionControl) lmap.attributionControl.addAttribution(OFM_ATTR);
    const gl = baseLayer.getMaplibreMap && baseLayer.getMaplibreMap();
    if (!gl) return;
    /* the odd missing tile is normal; a style that won't load at all is not */
    let errors = 0;
    const onError = () => { if (++errors >= 6) { gl.off('error', onError); useOsm(); } };
    gl.on('error', onError);
  }

  function svgFallback(msg){
    const lm = document.getElementById('lmap'), svg = document.getElementById('svg'), note = document.getElementById('mapNote');
    if (lm) lm.style.display = 'none';
    if (svg) svg.style.display = '';
    if (note) note.textContent = msg;
  }

  function initMap(){
    const el = document.getElementById('lmap');
    if (!window.L || !el) return false;
    el.style.display = 'block';
    const svg = document.getElementById('svg'), note = document.getElementById('mapNote');
    if (svg) svg.style.display = 'none';
    if (note) note.textContent = '600+ real stockists · drag to explore, click a pin for the address';

    /* maxZoom is required by the cluster plugin when the basemap is MapLibre */
    lmap = L.map(el, { scrollWheelZoom:false, zoomControl:true, maxZoom:18 });
    lmap.setView([-37.81, 144.96], 9);
    useBasemap();

    /* The map shouldn't swallow the page scroll — one click hands it the wheel */
    lmap.on('click focus', () => lmap.scrollWheelZoom.enable());
    lmap.on('mouseout blur', () => lmap.scrollWheelZoom.disable());

    cluster = L.markerClusterGroup ? L.markerClusterGroup({
      showCoverageOnHover:false,
      maxClusterRadius:48,
      iconCreateFunction: c => L.divIcon({
        className:'cl', html:'<span>' + c.getChildCount() + '</span>', iconSize:[38,38]
      })
    }) : L.layerGroup();
    lmap.addLayer(cluster);
    setTimeout(() => lmap.invalidateSize(), 60);
    return true;
  }

  function kmLabel(km){
    return km < 1 ? Math.round(km * 1000) + ' m' : km.toFixed(km < 10 ? 1 : 0) + ' km';
  }

  function getMarker(s){
    let m = markerFor.get(s);
    if (!m){
      m = L.marker([s.lat, s.lng], { icon:PIN, title:s.n, riseOnHover:true });
      m.on('click', () => {
        const row = rowFor.get(s);
        if (!row) return;
        listEl.querySelectorAll('.store.on').forEach(r => r.classList.remove('on'));
        row.classList.add('on');
        row.scrollIntoView({ block:'center', behavior:'smooth' });
      });
      markerFor.set(s, m);
    }
    m.setPopupContent(popupHtml(s));
    return m;
  }

  function popupHtml(s){
    return '<p class="pop__n"></p><p class="pop__a"></p>' +
           (s._km != null ? '<p class="pop__km">' + kmLabel(s._km) + ' away</p>' : '') +
           '<a class="pop__d" target="_blank" rel="noopener" href="https://www.google.com/maps/dir/?api=1&destination=' +
           s.lat + ',' + s.lng + '">Directions</a>';
  }

  /* text set separately so a store name can never inject markup */
  function bindPopup(s, m){
    m.bindPopup(popupHtml(s), { minWidth:210, maxWidth:268, autoPanPadding:[26,26] });
    m.on('popupopen', e => {
      const root = e.popup.getElement();
      root.querySelector('.pop__n').textContent = s.n;
      root.querySelector('.pop__a').textContent = [s.a, s.c, s.p].filter(Boolean).join(', ');
    });
  }

  function drawMap(hits){
    if (!lmap) return;
    cluster.clearLayers();
    hits.forEach(s => {
      const m = getMarker(s);
      if (!m.getPopup()) bindPopup(s, m);
      else m.setPopupContent(popupHtml(s));
      cluster.addLayer(m);
    });

    if (!hits.length) return;
    const pts = hits.map(s => [s.lat, s.lng]);
    if (here) pts.push([here.lat, here.lng]);
    /* one result shouldn't zoom to street level and lose all context */
    lmap.fitBounds(L.latLngBounds(hits.length > 6 && here ? pts.slice(0, 6).concat([[here.lat, here.lng]]) : pts),
                   { padding:[34,34], maxZoom: hits.length === 1 ? 15 : 13 });
  }

  function markMeOnMap(){
    if (!lmap || !here) return;
    if (meMarker){ lmap.removeLayer(meMarker); lmap.removeLayer(meHalo); }
    meHalo   = L.circle([here.lat, here.lng], { radius:1200, color:'#B69E58', weight:1, opacity:.5, fillOpacity:.06 }).addTo(lmap);
    meMarker = L.marker([here.lat, here.lng], { icon:PIN_ME, zIndexOffset:1000 }).addTo(lmap).bindPopup('You are here');
  }

  function clearMeOnMap(){
    if (lmap && meMarker){ lmap.removeLayer(meMarker); lmap.removeLayer(meHalo); meMarker = meHalo = null; }
  }

  function matches(s, q){
    if (activeState !== 'ALL' && s.s !== activeState) return false;
    if (!q) return true;
    return (s.n + ' ' + s.c + ' ' + s.p + ' ' + s.a).toLowerCase().includes(q);
  }

  function render(){
    const q = qEl.value.trim().toLowerCase();
    let hits = STOCKISTS.filter(s => matches(s, q));
    if (here) hits = hits.slice().sort((a,b) => a._km - b._km);

    listEl.innerHTML = '';
    let group = null;
    hits.forEach(s => {
      const key = here ? 'NEAR' : s.s;
      if (key !== group){
        group = key;
        const h = document.createElement('p');
        h.className = 'grp';
        h.textContent = here ? 'Nearest first' : (STATE_FULL[s.s] || 'Other');
        listEl.appendChild(h);
      }
      const el = document.createElement('div');
      el.className = 'store';
      el.innerHTML =
        '<div><p class="store__n"></p><p class="store__a"></p></div>' +
        '<div class="store__r">' +
          '<p class="store__s"></p>' +
          '<p class="store__km"></p>' +
          '<a class="dirs" target="_blank" rel="noopener">Directions</a>' +
        '</div>';
      el.querySelector('.store__n').textContent = s.n;
      el.querySelector('.store__a').textContent = [s.a, s.c, s.p].filter(Boolean).join(', ');
      el.querySelector('.store__s').textContent = s.s;
      if (s._km != null) el.querySelector('.store__km').textContent = kmLabel(s._km);
      const d = el.querySelector('.dirs');
      d.href = 'https://www.google.com/maps/dir/?api=1&destination=' + s.lat + ',' + s.lng;
      d.setAttribute('aria-label', 'Directions to ' + s.n);
      d.addEventListener('click', e => e.stopPropagation());
      rowFor.set(s, el);
      el.addEventListener('mouseenter', () => {
        const dot = dotFor.get(s); if (dot) dot.classList.add('cur');
        const m = markerFor.get(s), n = m && m.getElement();
        if (n) n.classList.add('cur');
      });
      el.addEventListener('mouseleave', () => {
        const dot = dotFor.get(s); if (dot) dot.classList.remove('cur');
        const m = markerFor.get(s), n = m && m.getElement();
        if (n) n.classList.remove('cur');
      });
      /* clicking a shop flies the map to it and opens its pin */
      el.addEventListener('click', () => {
        listEl.querySelectorAll('.store.on').forEach(r => r.classList.remove('on'));
        el.classList.add('on');
        const m = markerFor.get(s);
        if (!lmap || !m) return;
        if (cluster.zoomToShowLayer) cluster.zoomToShowLayer(m, () => m.openPopup());
        else { lmap.setView([s.lat, s.lng], 15); m.openPopup(); }
      });
      listEl.appendChild(el);
    });

    const hitSet = new Set(hits);
    dotFor.forEach((c, s) => c.classList.toggle('hit', hitSet.has(s)));
    drawMap(hits);

    resEl.textContent = hits.length === 0
      ? 'No stockists match — try a nearby suburb'
      : `${hits.length} ${hits.length === 1 ? 'stockist' : 'stockists'}` +
        (activeState !== 'ALL' ? ' in ' + (STATE_FULL[activeState] || activeState) : '') +
        (q ? ` matching “${qEl.value.trim()}”` : '');
  }

  /* Near me — distance and directions both come from the export's coordinates */
  let here = null;
  const geoBtn = document.getElementById('geo');

  function haversine(a, b){
    const R = 6371, rad = Math.PI/180;
    const dLat = (b.lat-a.lat)*rad, dLng = (b.lng-a.lng)*rad;
    const x = Math.sin(dLat/2)**2 +
              Math.cos(a.lat*rad)*Math.cos(b.lat*rad)*Math.sin(dLng/2)**2;
    return 2*R*Math.asin(Math.sqrt(x));
  }

  function setMsg(text){
    let m = document.querySelector('.geo__msg');
    if (!m){ m = document.createElement('span'); m.className = 'geo__msg'; geoBtn.after(m); }
    m.textContent = text || '';
  }

  let meDot = null;
  function markMe(){
    if (!dotsEl) return;
    if (!meDot){
      meDot = document.createElementNS('http://www.w3.org/2000/svg','circle');
      meDot.setAttribute('r','1.7'); meDot.setAttribute('class','me');
      dotsEl.appendChild(meDot);
    }
    const inside = here.lat <= maxLat && here.lat >= minLat && here.lng <= maxLng && here.lng >= minLng;
    meDot.setAttribute('cx', px(here).toFixed(2));
    meDot.setAttribute('cy', py(here).toFixed(2));
    meDot.style.display = inside ? '' : 'none';
  }

  if (geoBtn) {
    geoBtn.addEventListener('click', () => {
      if (here){
        here = null; geoBtn.setAttribute('aria-pressed','false');
        STOCKISTS.forEach(s => delete s._km);
        if (meDot) meDot.style.display = 'none';
        clearMeOnMap();
        setMsg(''); render(); return;
      }
      if (!navigator.geolocation){ setMsg('Location is not available in this browser.'); return; }
      setMsg('Finding you…');
      navigator.geolocation.getCurrentPosition(pos => {
        here = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        STOCKISTS.forEach(s => s._km = haversine(here, s));
        geoBtn.setAttribute('aria-pressed','true');
        markMe();
        markMeOnMap();
        const nearest = Math.min(...STOCKISTS.map(s => s._km));
        setMsg(`Closest stockist ${kmLabel(nearest)} away`);
        render();
      }, err => {
        setMsg(err.code === 1
          ? 'Location permission denied — search your suburb instead.'
          : 'Couldn’t get your location — search your suburb instead.');
      }, { enableHighAccuracy:false, timeout:8000, maximumAge:300000 });
    });
  }

  qEl.addEventListener('input', render);
  initMap();
  render();
})();
